const getPaymentIcon = brand => {
  switch (brand) {
    case 'Visa':
      return ['fab', 'cc-visa'];
    case 'American Express':
      return ['fab', 'cc-amex'];
    case 'MasterCard':
      return ['fab', 'cc-mastercard'];
    case 'PayPal':
      return ['fab', 'cc-paypal'];
    case 'Discover':
      return ['fab', 'cc-discover'];
    case 'Jcb':
      return ['fab', 'cc-jcg'];
    case 'Diners Club':
      return ['fab', 'cc-diners-club'];
    default:
      return ['fal', 'credit-card-front'];
  }
};

export default getPaymentIcon;
